<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="arrest-and-detention">
<h1>Arrest and Detention</h1>
<p>The prisoner was awakened by the charitable action of Sergeant George Caffrey who, as much in feelings of disgust as of pity, having briefly unlocked the holding cell, provided him with a glass of water which he placed on the concrete floor.</p>
<p>“Drink this up,” he had muttered as he retreated from the cell with feelings of embarrassment, not knowing how to relate to a long-term friend who had brought disgrace upon himself before being eventually subdued in the lounge bar of Cavanaugh’s pub. George later described the episode as one of the most violent arrests in his history of policing. He had been unprepared for the power of the man who threw young officer Eames across the pub floor before slamming George against the wall, next turning to confront Frank Furlong who had been attempting to subdue him by striking him repeatedly on the head with his baton. He was finally overpowered and handcuffed as a result of the intervention of Officer Graham who, fearing the situation was becoming uncontrollable, resorted to the expedient of kicking the man so severely in the groin as to render him temporarily paralysed.</p>
<p>On being released from police custody, John was informed that he would later be summoned to appear before the local magistrates. Without response, he left abruptly and headed towards the home of his wife and remaining child.</p>
<p>Following the departure of John Kelly his long-time friend, George Caffrey, reflected on the radical transformation of the man following his nerve-wracking experiences as a mercenary soldier in Africa.</p>
<p>George was universally regarded within the town as a clear thinking, rational man whose reasoned approach to complex issues in the course of criminal investigation, or more routine social and domestic matters, reflected the mindset of one who routinely found satisfaction in a professional policing approach of thoughtful enquiry and logical resolution. In times of exceptional stress, he sought release in his long-time interest in philosophy and mathematics.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?b776f7c0